import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const routes = [
  {
    path: '*',
    redirect: '/'
  }, {
    path: '/',
    // name: 'PageView',
    component: resolve => require(['@/view/PageView'], resolve),
    children: [
      {
        path: '/',
        redirect: '/home'
      }, {
        path: '/home',
        name: 'home',
        component: resolve => require(['@/view/HomePage'], resolve),
        meta: {
          title: '首页'
        }
      }, {
        path: '/software',
        name: 'software',
        component: resolve => require(['@/view/Software'], resolve),
        meta: {
          title: '案例展示'
        },
        children: [
          {
            path: '/software',
            redirect: '/software/smartTown'
          },
          {
            path: '/software/smartTown',
            name: 'softwaresmartTown',
            component: resolve => require(['@/view/Software_smartTown'], resolve),
            meta: {
              title: '案例展示丨会务会展'
            }
          },
          {
            path: '/software/bigData',
            name: 'softwarebigData',
            component: resolve => require(['@/view/Software_bigData'], resolve),
            meta: {
              title: '案例展示丨展览展示'
            }
          }
        ]
      }, {
        path: '/fuwuware',
        name: 'fuwuware',
        component: resolve => require(['@/view/fuwu/fuwuware'], resolve),
        meta: {
          title: '产品服务'
        },
        children: [
          {
            path: '/fuwuware',
            redirect: '/fuwuware/fuwu1'
          },
          {
            path: '/fuwuware/fuwu1',
            name: 'fuwuwarefuwu1',
            component: resolve => require(['@/view/fuwu/fuwu1'], resolve),
            meta: {
              title: '产品服务丨冰河学术活动管理系统'
            }
          },
          {
            path: '/fuwuware/fuwu2',
            name: 'fuwuwarefuwu2',
            component: resolve => require(['@/view/fuwu/fuwu2'], resolve),
            meta: {
              title: '产品服务丨现场注册签到平台'
            }
          }, {
            path: '/fuwuware/fuwu3',
            name: 'fuwuwarefuwu3',
            component: resolve => require(['@/view/fuwu/fuwu3'], resolve),
            meta: {
              title: '产品服务丨会场幻灯片传输系统'
            }
          }, {
            path: '/fuwuware/fuwu4',
            name: 'fuwuwarefuwu4',
            component: resolve => require(['@/view/fuwu/fuwu4'], resolve),
            meta: {
              title: '产品服务丨冰河直播系统'
            }
          }, {
            path: '/fuwuware/fuwu5',
            name: 'fuwuwarefuwu5',
            component: resolve => require(['@/view/fuwu/fuwu5'], resolve),
            meta: {
              title: '产品服务丨冰河征文系统'
            }
          }, {
            path: '/fuwuware/fuwu6',
            name: 'fuwuwarefuwu6',
            component: resolve => require(['@/view/fuwu/fuwu6'], resolve),
            meta: {
              title: '产品服务丨冰河线下壁报系统'
            }
          }, {
            path: '/fuwuware/fuwu7',
            name: 'fuwuwarefuwu7',
            component: resolve => require(['@/view/fuwu/fuwu7'], resolve),
            meta: {
              title: '产品服务丨企业数字营销服务'
            }
          },
        ]
      }, {
        path: '/service',
        name: 'service',
        component: resolve => require(['@/view/Service'], resolve),
        meta: {
          title: '相关服务'
        }
      }, {
        path: '/newsinformation',
        name: 'newsinformation',
        component: resolve => require(['@/view/NewsInformation'], resolve),
        meta: {
          title: '新闻动态'
        }
      }, {
        path: '/companyintroduction',
        name: 'companyintroduction',
        component: resolve => require(['@/view/CompanyIntroduction'], resolve),
        meta: {
          title: '公司介绍'
        }
      }, {
        path: '/jobchance',
        name: 'jobchance',
        component: resolve => require(['@/view/JobChance'], resolve),
        meta: {
          title: '工作机会'
        }
      }, {
        path: '/contactus',
        name: 'contactus',
        component: resolve => require(['@/view/ContactUs'], resolve),
        meta: {
          title: '联系我们'
        }
      },
      {
        path: '/servicedetail',
        name: 'servicedetail',
        component: resolve => require(['@/view/ServiceDetail'], resolve),
        meta: {
          title: '相关服务'
        }
      }
    ]
  }
]
export default new Router({
  routes,
  linkActiveClass: 'activeRouter',
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js